export default "__VITE_ASSET__1040690b__"